import textProvider from './textProvider';

export default textProvider;